import { CommonApiErrorHandlerService } from '../../../../shared/services/common-api-error-handler.service';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Rx';
import { SessionService } from '../session/session.service';
import { ConfigurationService } from '../configuration/configuration.service';
import 'rxjs-compat/add/observable/dom/webSocket';
import { WSEventType } from '../../../models/WSEventType';
import { RxWebsocketSubject } from './rx-websocket-subject';
import { MetricsService } from '../../../../shared/services/metrics.service';
import { MetricsType } from '../../../../shared/components/models/metrics/metrics-type.enum';

@Injectable()
export class WebSocketService {

  eventStream: Subject<any>;
  isConnected: boolean = false;
  private readonly wsUrl: string;
  private ws: RxWebsocketSubject<any>;
  private interval;

  constructor(private sessionService: SessionService,
              private configuration: ConfigurationService,
              private metricsService: MetricsService,
              private commonApiErrorHandlerService: CommonApiErrorHandlerService) {
    this.wsUrl = this.configuration.uiConfig.notificationEndpoint;
    this.eventStream = new Subject();
  }

  connect() {
    try {
      this.ws = new RxWebsocketSubject(this.wsUrl, this.metricsService);

      this.setPingMessageInterval();

      this.ws.subscribe(
        (next) => {
          const status = next.body ? next.body.status : next.status.statusCode;
          if (status === 500 || status === 404) {
            this.commonApiErrorHandlerService.emitError(next.body);
            this.clearInterval();
          } else {
            this.processEvent(next);
          }
        },
        error => {
          this.clearInterval();
        },
        () => {
          this.clearInterval();
        }
      );
      this.authenticate();
      this.isConnected = true;
    } catch (error) {
      this.metricsService.sendSimpleMetric(
        'WebSocketService:connect:error',
        MetricsType.WEBSOCKET,
        JSON.stringify(error)
      );
    }
  }

  disconnect() {
    this.ws.disconnect();
    this.clearInterval();
    this.isConnected = false;
  }

  private authenticate() {
    let sessionId = this.sessionService.sessionId;
    let data = '{"sessionId":"' + sessionId + '"}';
    this.ws.send(JSON.parse(data));
  }

  private processEvent(data: any) {
    this.eventStream.next(data);
  }

  private setPingMessageInterval() {
    let pingMessage = {
      sessionId: this.sessionService.sessionId,
      messageType: WSEventType.PING
    };
    this.interval = setInterval(() => {
      this.ws.send(pingMessage);
    }, 15000);
  }

  private clearInterval() {
    clearInterval(this.interval);
  }
}
